export const shouldLoad = () => document.querySelector('[data-controller="icon-cards-section"]') !== undefined;